import React from 'react';
import { FaucetElevation } from './FaucetElevation';
import {
  bathroomSinkFaucetProfile,
  resolveBathroomSinkFaucetVariant,
} from '../../3d/geometry/proceduralRenderers/proceduralSpecs';

/**
 * Bathroom sink (lavatory) faucet elevation. Variants
 * (`resolveBathroomSinkFaucetVariant`, shared with the 3D renderer):
 * single-handle (default), centerset, widespread, wall-mount — from
 * `obj.mountType` (the catalog drilling enum) or `obj.wallMounted`, the flag
 * `createSinkFaucet` stamps on a wall-mount. Drawn by `FaucetElevation` over
 * `bathroomSinkFaucetProfile`.
 */
export { resolveBathroomSinkFaucetVariant };

export function BathroomSinkFaucetSchematic({
  widthMeters,
  heightMeters,
  depthMeters,
  obj = {},
  strokeColor,
  strokeWidth,
  view = 'front',
}) {
  const dims = { width: widthMeters, height: heightMeters, depth: depthMeters };
  const profile = bathroomSinkFaucetProfile(
    dims,
    resolveBathroomSinkFaucetVariant(obj)
  );
  return (
    <FaucetElevation
      profile={profile}
      view={view}
      widthMeters={widthMeters}
      heightMeters={heightMeters}
      depthMeters={depthMeters}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    />
  );
}

BathroomSinkFaucetSchematic.supportsSideViews = true;
